// extracted by mini-css-extract-plugin
module.exports = {"Title":"TwoColumnsListView-module--Title--3BUfj","Container":"TwoColumnsListView-module--Container--3jXgl","ListContainer":"TwoColumnsListView-module--ListContainer--fOeTf"};